"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleOAuthContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const useLoadGsiScript_1 = __importDefault(require("../../hooks/useLoadGsiScript"));
const GoogleOAuthContext = (0, react_1.createContext)({});
exports.GoogleOAuthContext = GoogleOAuthContext;
const GoogleOAuthProvider = ({ onScriptLoadSuccess, onScriptLoadError, clientId, locale, children, }) => {
    const scriptLoadedSuccessfully = (0, useLoadGsiScript_1.default)({
        onScriptLoadSuccess,
        onScriptLoadError,
        locale,
    });
    const contextValue = (0, react_1.useMemo)(() => ({
        clientId,
        scriptLoadedSuccessfully,
    }), [scriptLoadedSuccessfully]);
    return ((0, jsx_runtime_1.jsx)(GoogleOAuthContext.Provider, { value: contextValue, children: children }));
};
exports.default = GoogleOAuthProvider;
